module.exports = __webpack_public_path__ + "static/img/banner-bg.6b9b6245.png";